/*
 * Module for Example Translation
 */

define([
  "marionette",
  "messaging/messenger",
  "modules/topicsSplit/topic/topicExampleModal/exampleTranslation/exampleTranslationView",
  "modules/topicsSplit/topic/topicExampleModal/exampleTranslation/exampleTranslationModel",
], function (Marionette, Messenger, ExampleTranslationView, ExampleTranslationModel) {
  var ExampleTranslationController = Marionette.Controller.extend({
    initialize: function (options) {
      this.region = options.region;
      this.name = "exampleTranslation";
      this.lastEvaluatedExample = null;
      this._setUpVents();
    },
    show: function (example) {
      this.exampleModel = example; //keep track of the example we are editing
      this.exampleTranslationModel = new ExampleTranslationModel.exampleTranslationModel();
      const isEnglish = Messenger.reqres.request(
        "kb:language:is:english",
        +example.get("localeId"),
      );
      if (example.get("englishTranslation") && !isEnglish) {
        // when the example modal is opened for the first time after entering into the topic, use translation that is
        // in the database. But make sure when the example is changed by user, the changed example text is used to
        // get fresh translation.
        this.exampleTranslationModel.set("exampleText", example.get("englishTranslation"));
      }
      if (isEnglish) {
        this.exampleTranslationModel.set("exampleText", "");
      }
      this.view = new ExampleTranslationView.exampleTranslationView({
        model: this.exampleTranslationModel,
      });
      this.showRegion(this.view);
    },
    _fetchEnglishTranslation: function (example) {
      const localeId = +example.get("localeId");
      if (!Messenger.reqres.request("kb:language:is:english", localeId)) {
        const exampleString = this._buildExampleString(example.entries());
        if (exampleString) {
          this.exampleTranslationModel.getTranslation(exampleString, localeId);
          this.exampleTranslationModel.onSynced(function () {
            // update example model. This is for preview only. This field will not be used by server to update the database
            // with the new translation.
            example.set("englishTranslation", this.exampleTranslationModel.get("exampleText"));
          }, this);
        }
      } else {
        // english locale
        // set the translation text to empty as we do not want to show any text for english
        this.exampleTranslationModel.set("exampleText", "");
        this.showRegion(this.view);
      }
    },
    _buildExampleString: function (exampleEntries) {
      let exampleString = "";
      exampleEntries.each(function (entry) {
        exampleString += entry.get("surfaceForm") + " ";
      }, this);
      exampleString = exampleString.trimStrict();
      return exampleString;
    },
    _setUpVents: function () {
      Messenger.vent.on(
        "fetch:english:translation",
        function (example) {
          this._fetchEnglishTranslation(example);
        },
        this,
      );
      Messenger.vent.on(
        "hide:example:translation",
        function () {
          // simply empty the translated example text and re-render
          this.exampleTranslationModel.set("exampleText", "");
          this.showRegion(this.view);
        },
        this,
      );
    },
  });

  return ExampleTranslationController;
});
